<template>
  <img v-show="currentSrc" ref="imgField" class="auth-img" :src="currentSrc" @click.stop="onClick" />
</template>

<script>
import ImageViewer from "@/components/Image-viewer/ImageViewer.vue";

export default {
  name: "AuthImage",

  props: {
    path: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      currentSrc: "",
    };
  },

  async created() {
    this.requestImage();
  },

  destroyed() {
    URL.revokeObjectURL(this.currentSrc);
  },

  methods: {
    requestImage() {
      let request = new XMLHttpRequest();
      request.responseType = "blob";
      request.open("get", this.path, true);
      request.setRequestHeader("Authorization", this.$store.state.auth.accessToken);
      request.onreadystatechange = e => {
        if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
          this.currentSrc = URL.createObjectURL(request.response);
          // element.src = URL.createObjectURL(request.response);
          if (this.$refs.imgField) {
            this.$refs.imgField.onload = () => {
              // URL.revokeObjectURL(this.currentSrc);
            };
          }
        }
      };
      request.send(null);
    },

    onClick() {
      this.$dialog.show(ImageViewer, {
        src: this.currentSrc,
        width: 600,
      });
    },
  },
};
</script>

<style scoped>
.auth-img {
  max-width: 100%;
  height: auto;
}
</style>
